import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchGrouptripsDtlbannersec } from "../services/GrouptripsDtlbannersec";
import { API_BASE } from "../api/apiConfig";

const GrouptripsDtlsimilar = () => {
  const { id } = useParams();

  const [GrouptripsDtlsimilar, setGrouptripsDtlsimilar] = useState(null);
  const [similarTrips, setSimilarTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      const res = await fetchGrouptripsDtlbannersec(decodeURIComponent(id));

      if (res?.status) {
        // Main trip
        setGrouptripsDtlsimilar(res.data?.[0] || null);

        // Similar trips
        setSimilarTrips(res.tourexcursionslist || []);
      }

      setLoading(false);
    };

    loadData();
  }, [id]);

  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!GrouptripsDtlsimilar)
    return <p className="text-center py-10">No data found</p>;

  return (
    <>
     {/* Similar Trips */}
    <section className="py-8 md:py-12 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-6 md:mb-8">
              <h2 className="text-xl md:text-2xl font-bold text-slate-800 mb-2">
                Similar Trips You Might Like
              </h2>
              <p className="text-slate-600 text-sm md:text-base">
                Explore more exciting adventures
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">

        {similarTrips.map((trip) => (
              <a  key={trip.id}
                className="group relative rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300"
                href={`/GroupTripsDtl/${trip.id}`}
              >
                <div className="relative h-48 md:h-56 w-full overflow-hidden">
                  <img
                    alt={trip.name}
                    loading="lazy"
                    decoding="async"
                    data-nimg="fill"
                    className="object-cover transition-transform duration-500 group-hover:scale-110"
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      left: 0,
                      top: 0,
                      right: 0,
                      bottom: 0,
                      color: "transparent"
                    }}
                    src={`${API_BASE}/${trip.images}`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                    <h3 className="text-base md:text-lg font-bold mb-1.5">
                     {trip.name}
                    </h3>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-1.5">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-map-pin h-3.5 w-3.5"
                        >
                          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                          <circle cx={12} cy={10} r={3} />
                        </svg>
                        <span className="text-xs md:text-sm">{trip.city}</span>
                      </div>
                      <div className="text-base md:text-lg font-bold">
                        ₹{trip.charges}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="absolute top-3 right-3">
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-teal-500 text-white border-none text-xs">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star h-3 w-3 mr-1 fill-white"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    4.7
                  </div>
                </div>
              </a>
        ))}

            </div>
            <div className="text-center mt-6 md:mt-8">
              <a href="/grouptrips">
                <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-9 rounded-md px-3 bg-teal-500 hover:bg-teal-600 text-white text-sm md:text-base">
                  View All Group Trips
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-arrow-right ml-2 h-4 w-4"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </button>
              </a>
            </div>
          </div>
        </section>
    </>
  );
};

export default GrouptripsDtlsimilar;
